export default [
  {
    featureType: "poi.business",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "transit.station.bus",
    stylers: [
      {
        visibility: "off"
      }
    ]
  }
];
